<template>
  <div class="row " v-bind:style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}">
    <div class="col-12">
      <div class="custom-info-four">
        <div class="row m-0">
          <div class="col-7 py-3 d-flex info-wrapper px-5" v-bind:style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}">
            <div class="info-section w-50 pr-3">
              <p v-if="quote_data != undefined">
                <b v-bind:style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}" v-if="quote_data.owner.name != null && quote_data.owner.name != undefined">{{quote_data.owner.name}} {{quote_data.owner.last_name}}</b>
              </p>
              <p v-else>
                <b v-bind:style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}">Nombre del vendedor</b>
              </p>
              <p v-if="quote_data != undefined">
                  <span v-if="quote_data.owner.company != undefined && quote_data.owner.company != null">
                    {{quote_data.owner.company}}
                  </span>
                </p>
                <p v-else>
                  Nombre de la empresa
                </p>

                <p v-if="quote_data != undefined">
                  <span v-if="quote_data.owner.address != undefined && quote_data.owner.address != null">
                    {{quote_data.owner.address}}
                  </span>
                </p>
                <p v-else>
                  Dirección de la empresa
                  <br>
                  Colonia y todo eso...
                </p>

                <p class="mt-3" v-if="quote_data != undefined">
                  <a :href="quote_data.owner.page" target="_blank" v-if="quote_data.owner.page != null && quote_data.owner.page != undefined" v-bind:style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}">
                    {{quote_data.owner.page}}
                  </a>
                </p>
                <p class="mt-3" v-else>
                  www.paginaweb.com
                </p>
            </div>

            <div class="w-50 ml-3 pl-3">
              <div v-if="quote_data != undefined">
                <div v-for="(client) in quote_data.clients" :key="client.email">
                  <p>
                    <b v-bind:style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}">{{client.name}} {{client.last_name}}</b>
                  </p>
                  <p>{{client.email}}</p>
                  <p>{{client.company}}</p>
                </div>
              </div>
              <div v-else>
                <div >
                  <p>
                    <b v-bind:style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}">Nombre del cliente</b>
                  </p>
                  <p>correo@cliente.mx</p>
                  <p>Empresa cliente</p>
                </div>
                <div class="my-1">
                  <p>
                    <b v-bind:style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}">Nombre del cliente</b>
                  </p>
                  <p>correo@cliente.mx</p>
                  <p>Empresa cliente</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-5" v-if="settings_style.view_notes && quote_data != undefined" v-bind:style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}">
            <div class="notes-wrapper p-4" v-bind:style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}" v-if="quote_data.details.notes != null">
              NOTAS:
              <div v-html="quote_data.details.notes"></div>
            </div>
          </div>

          <div class="col-5" v-else-if="settings_style.view_notes" v-bind:style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}">
            <div class="notes-wrapper p-4" v-bind:style="{color : settings_style.colors != undefined ? settings_style.colors[4].color_value : 'white'}">
              NOTAS:
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident quaerate, unde doloremque maiores reiciendis corrupti.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    settings_style: {
      required: true,
    },
    quote_data:{
      type:Object
    }    
  },
};
</script>